import { Link as LinkRecord } from 'records/Link';

class Link {
  bbox: number[];

  _onclick: (link: LinkRecord) => void;

  link: LinkRecord;

  constructor(
    bbox: number[],
    onclick: (link: LinkRecord) => void,
    link: LinkRecord
  ) {
    this.bbox = bbox;
    this._onclick = onclick;
    this.link = link;
  }

  onClick(): void {
    this._onclick(this.link);
  }
}

export default Link;
